import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import GapTimers from "../../../../../components/Collections/GapTimers";

const breadcrumbStatic = [{
	name: 'KPI Metrics',
	url: '/admin/kpi_metrics',
	icon: 'dashboard'
}];

export default class Kpi_Metrics extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>

				<Collections.KpiMetrics/>

			</div>


		)
	}
}